import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
//import Fly from 'fly'
//import VueResource from 'vue-resource'

import MaterialKit from "./plugins/material-kit";

Vue.config.productionTip = false;

Vue.use(MaterialKit);
//Vue.use(Fly);
//Vue.use(VueResource);

const NavbarStore = {
  showNavbar: false
};

//Vue.http.options.root = 'http://studio.viainno.com:8080/';
//Vue.http.headers.common['X-USER-GUID'] = 'setpassword'

//axios.defaults.baseURL = 'https://studio.viainno.com/'
axios.defaults.baseURL ='https://spacesgoapi.azurewebsites.net'
//axios.defaults.baseURL ='https://192.168.8.91'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['X-USER-GUID'] = 'setpassword'
Vue.prototype.$http = axios;



// var fly = new Fly()
// Vue.prototype.$fly = fly
// fly.config.baseURL = process.env.BASE_API
// fly.config.timeout = 15000

// fly.interceptors.request.use((request) => {
//   request.headers['Content-Type'] = 'application/json'  
//   request.headers['X-USER-GUID'] = 'setpassword'
//   return request
// })

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
